<div
  class="form-group"
  [class.required]="isRequired"
  [formGroup]="parentForm"
  *ngIf="control"
>
  <mat-form-field
    [floatLabel]="'always'"
    appearance="fill"
    [class.readonly]="readOnlyCss"
  >
    <input
      matInput
      type="text"
      mask="00/00/0000"
      [validation]="false"
      placeholder="jj/mm/aaaa"
      [class.is-invalid]="control.invalid && control.touched"
      class="form-control"
      [formControlName]="formControlName"
    />
  </mat-form-field>
</div>
